<div class="max-units-notice" role="status">
  <div class="max-units-notice__icon" aria-hidden="true">
    !
  </div>

  <div class="max-units-notice__content">
    <p class="max-units-notice__title">
      Alcanzaste el máximo de {{ maxUnits }} unidades
    </p>

    <p class="max-units-notice__text">
      ¿Necesitas más? Podemos prepararlo como un encargo personalizado.
    </p>

    <div class="max-units-notice__actions">
      <a
        class="max-units-notice__btn max-units-notice__btn--primary"
        href="/encargo"
        target="_blank"
        rel="noopener noreferrer"
      >
        Hacer un encargo
      </a>

      <a
        class="max-units-notice__link"
        [href]="whatsappLink()"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contactar por WhatsApp
        <span aria-hidden="true">→</span>
      </a>
    </div>
  </div>
</div>
